import axios from 'axios'
import { MessageBox } from 'element-ui';
import store from '@/store/index.js';
import config from '@/config'
axios.defaults.withCredentials = true// 让ajax携带cookie
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.common['x-requested-with'] = 'XMLHttpRequest'
const passportUrl = config[process.env.NODE_ENV].passportUrl
// 创建 axios 实例
const service = axios.create({
  baseURL: '/',
  timeout: 20000, // 请求超时时间
})

const err = error => {
  if (error.response) {
    const data = error.response.data
    if (error.response.status === 403) {
      // Message({ message: 'Forbidden', description: data.message })
    }
    if (error.response.status === 401) {
      // Message({ message: 'Unauthorized', description: 'Authorization verification failed' })
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {

  // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  return config
}, err)

// response interceptor
service.interceptors.response.use(response => {
  console.log(response.config.url)
  if(response.config.url === '/api/user/mp/detail'){
    console.log(1)
  }else{
    console.log(2)
    if (response.data.code === 401) {
      store.commit('userDetail','')
      // window.location.href = passportUrl + '?client_id=sbw&redirectUrl=' + window.location.href;
    }
  }
  return response.data
}, err)

export { service as axios }
